import type { UUID } from "@cp/toolkit";
import { type CarrierContactFragment, useCarrierContactsQuery } from "@qw/graphql";
import { FieldCombobox, Form } from "@qw/ui";
import { useMemo } from "react";

interface Props {
  setSelected: (contact: CarrierContactFragment | null) => void;
  excludedContactIds?: string[];
}

const createNew: CarrierContactFragment = {
  __typename: "CarrierContact",
  id: "new" as UUID,
  firstName: "Create New",
  lastName: "",
  email: "",
  phone: "",
  title: "",
};

export const CarrierContactSelector: React.FC<Props> = ({ setSelected, excludedContactIds = [] }) => {
  const { data } = useCarrierContactsQuery();

  const { contacts, options } = useMemo(() => {
    const filteredContacts = data?.carrierContacts?.filter((contact) => !excludedContactIds.includes(contact.id)) || [];
    const contacts = [...filteredContacts, createNew];
    const options = contacts.map((contact) => ({
      value: contact.id,
      label: `${contact.firstName} ${contact.lastName} ${contact.email}`,
      persistent: contact.id === "new",
    }));
    return { contacts, options };
  }, [data?.carrierContacts, excludedContactIds]);

  const handleChange = (value: string) => {
    const selectedContact = contacts.find((contact) => contact.id === value);
    setSelected(selectedContact || null);
  };

  return (
    <Form>
      <FieldCombobox
        placeholder="Search Contacts"
        name="carrierContacts"
        options={options}
        onChange={handleChange as any}
      />
    </Form>
  );
};
